export default "assets/images/icons/chevron-sm-73018201.svg";